import { render, staticRenderFns } from "./AbaTroncoPjsip.vue?vue&type=template&id=9f72e902&scoped=true&"
import script from "./AbaTroncoPjsip.vue?vue&type=script&lang=js&"
export * from "./AbaTroncoPjsip.vue?vue&type=script&lang=js&"
import style0 from "./AbaTroncoPjsip.vue?vue&type=style&index=0&id=9f72e902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f72e902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VDivider,VForm,VRow,VSelect,VSheet,VSkeletonLoader,VTextField})
